import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import './CellBase.scss';

import CellBase from './CellBase';
import RetinaImage from '../RetinaImage';

import defaultUser from './images/default-user.png';

export default class UserCell extends CellBase {
    static displayName = displayName('TableView/UserCell');

    static propTypes = {
        ...CellBase.propTypes,
        userName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        image: PropTypes.any,
    };

    static contextTypes = CellBase.contextTypes;

    static defaultProps = {
        ...CellBase.defaultProps,
        image: defaultUser,
        cellType: 'user',
    };

    renderCell() {
        const { userName, image } = this.props;

        return (
            <data>
                <RetinaImage className="user-image" image={image} />
                <span>
                    {userName}
                </span>
            </data>
        );
    }
}
